@if (vista; as v) {
  <section class="detalle">
    <!-- Resumen: estado y lo más consultado. La identidad (identificación,
         dirección, tipo, cliente) está en el encabezado de la página. -->
    <app-dt-card>
      <app-dt-datos destacado>
        <app-dt-dato etiqueta="Estado" ocultarVacio>
          <app-dt-estado
            [tono]="v.estado.tono"
            [etiqueta]="v.estado.etiqueta"
          />
          @if (v.estado.alarmas.length) {
            <span class="dt-muted fecha">
              {{ v.estado.alarmas.join(', ') }}
            </span>
          }
        </app-dt-dato>
        <app-dt-dato etiqueta="Comunicación" ocultarVacio>
          <app-dt-estado
            [tono]="v.comunicacion.tono"
            [etiqueta]="v.comunicacion.etiqueta"
          />
          @if (v.hace) {
            <span class="dt-muted fecha">
              hace {{ v.hace }} · {{ v.ultimaComunicacion }}
            </span>
          }
        </app-dt-dato>
        <app-dt-dato etiqueta="Encendida (últimas 24 h)" [valor]="v.horas24" />
        <app-dt-dato etiqueta="Consumo (últimas 24 h)" [valor]="v.consumo24" />
      </app-dt-datos>
    </app-dt-card>

    <!-- Grilla de tarjetas en orden fijo. El mapa es una tarjeta más: arriba
         a la derecha, del alto de las dos primeras. -->
    <div class="grilla">
      <app-dt-card titulo="Luminaria" icono="lightbulb" class="tarjeta">
        <app-dt-datos>
          <app-dt-dato
            etiqueta="Marca y modelo"
            [valor]="v.marcaModelo ?? 'Sin modelo asignado'"
          />
          <app-dt-dato etiqueta="Horas de vida" [valor]="v.horasVida" />
          <app-dt-dato
            etiqueta="Horas encendida (total)"
            [valor]="v.horasTotales"
          />
          <app-dt-dato etiqueta="Grupos" [valor]="v.grupos ?? 'Sin grupos'" />
          <app-dt-dato etiqueta="Perfil" [valor]="v.perfil ?? 'Sin perfil'">
            @if (v.perfilOrigen) {
              <span class="dt-muted fecha">{{ v.perfilOrigen }}</span>
            }
          </app-dt-dato>
          @if (v.puesta) {
            <app-dt-dato etiqueta="Puesta" [valor]="v.puesta" />
          }
          <app-dt-dato
            etiqueta="Estado operativo"
            [valor]="v.estadoOperativo"
          />
          <app-dt-dato etiqueta="Fecha de creación" [valor]="v.fechaCreacion" />
        </app-dt-datos>
      </app-dt-card>

      @if (mapCardConfig) {
        <div class="tarjeta-mapa">
          <div class="mapa" #tarjetaMapa>
            <app-map-card
              [height]="
                pantallaAncha() && altoMapa() ? altoMapa() + 'px' : '320px'
              "
              [config]="mapCardConfig"
            ></app-map-card>
          </div>
        </div>
      }

      <!-- Comunicación: el estado y la fecha ya están en el resumen -->
      <app-dt-card titulo="Comunicación" icono="cell_tower" class="tarjeta">
        <app-dt-datos>
          <app-dt-dato
            etiqueta="Frecuencia de reporte"
            [valor]="v.frecuencia"
          />
          <app-dt-dato etiqueta="Señal" [valor]="v.senal" />
          <app-dt-dato etiqueta="RSSI" [valor]="v.rssi" />
          <app-dt-dato etiqueta="SNR" [valor]="v.snr" />
          <app-dt-dato etiqueta="Tasa de entrega" [valor]="v.tasaEntrega" />
          <app-dt-dato
            etiqueta="Sin comunicación a las"
            [valor]="v.tiempoLimite"
          />
        </app-dt-datos>
      </app-dt-card>

      <app-dt-card titulo="Eléctrico" icono="bolt" class="tarjeta">
        <app-dt-datos>
          <app-dt-dato etiqueta="Dimerización" [valor]="v.dimerizacion" />
          <app-dt-dato etiqueta="Potencia" [valor]="v.potencia.actual">
            @if (v.potencia.nominal) {
              <span class="dt-muted fecha">
                nominal {{ v.potencia.nominal }}
              </span>
            }
          </app-dt-dato>
          <app-dt-dato
            etiqueta="Factor de potencia"
            [valor]="v.factorPotencia.actual"
          >
            @if (v.factorPotencia.nominal) {
              <span class="dt-muted fecha">
                nominal {{ v.factorPotencia.nominal }}
              </span>
            }
          </app-dt-dato>
          <app-dt-dato etiqueta="Voltaje" [valor]="v.voltaje.actual">
            @if (v.voltaje.nominal) {
              <span class="dt-muted fecha">
                nominal {{ v.voltaje.nominal }}
              </span>
            }
          </app-dt-dato>
        </app-dt-datos>
      </app-dt-card>

      <app-dt-card titulo="Dispositivo LoRaWAN" icono="router" class="tarjeta">
        <app-dt-datos>
          <app-dt-dato etiqueta="Nombre" [valor]="v.lora.nombre" />
          <app-dt-dato
            etiqueta="DevEUI"
            [valor]="v.lora.deveui"
            mono
            copiable
          />
          <app-dt-dato etiqueta="Marca y modelo" [valor]="v.lora.marcaModelo" />
          <app-dt-dato
            etiqueta="Frecuencia del último uplink"
            [valor]="v.lora.frecuenciaUplink"
          />
          <app-dt-dato
            etiqueta="Data rate del último uplink"
            [valor]="v.lora.dataRate"
          />
          <app-dt-dato
            etiqueta="Fecha de creación"
            [valor]="v.lora.fechaCreacion"
          />
        </app-dt-datos>
      </app-dt-card>

      <app-dt-card
        [titulo]="tituloConsumoMensual"
        icono="bolt"
        class="tarjeta ancha"
      >
        <app-date-picker
          class="periodo"
          mode="monthrange"
          label="Período"
          [maxDate]="hoy"
          [(ngModel)]="rangoMesesConsumo"
          (ngModelChange)="onRangoMesesChange($event)"
        ></app-date-picker>
        @if (chartCardConfigConsumoMensual) {
          <app-chart-card
            class="grafico"
            [config]="chartCardConfigConsumoMensual"
            chartHeight="260px"
          ></app-chart-card>
        }
      </app-dt-card>

      <!-- Especificaciones eléctricas del modelo de luminaria -->
      <app-dt-card
        titulo="Especificaciones del modelo"
        icono="memory"
        class="tarjeta ancha"
      >
        @if (!tieneModelo) {
          <div class="aviso advertencia">
            <mat-icon>error_outline</mat-icon>
            <div>
              <strong>Sin modelo asignado</strong>
              <span class="dt-muted">
                Sin modelo no hay márgenes de potencia, voltaje ni factor de
                potencia para mostrar.
              </span>
            </div>
          </div>
        } @else if (!tieneEspecificaciones) {
          <span class="dt-muted">
            El modelo asignado no tiene cargadas especificaciones eléctricas
            (voltaje o curva de dimerización).
          </span>
        } @else {
          <div class="especificaciones">
            @if (voltajeModelo) {
              <app-dt-datos>
                <app-dt-dato
                  etiqueta="Voltaje nominal"
                  [valor]="
                    voltajeModelo.nominalV !== null
                      ? voltajeModelo.nominalV + ' V'
                      : null
                  "
                />
                <app-dt-dato
                  etiqueta="Margen superior"
                  [valor]="
                    voltajeModelo.margenSuperiorV !== null
                      ? '+' + voltajeModelo.margenSuperiorV + ' V'
                      : null
                  "
                />
                <app-dt-dato
                  etiqueta="Margen inferior"
                  [valor]="
                    voltajeModelo.margenInferiorV !== null
                      ? '−' + voltajeModelo.margenInferiorV + ' V'
                      : null
                  "
                />
              </app-dt-datos>
            }

            <!-- Márgenes de potencia y FP (mismo componente que crear/editar
                 modelo de luminaria) -->
            <div class="curvas">
              <app-curva-luminaria-chart
                metric="potencia"
                [dimerizacion]="dimerModelo"
                [frameless]="true"
              ></app-curva-luminaria-chart>
              <app-curva-luminaria-chart
                metric="fp"
                [dimerizacion]="dimerModelo"
                [frameless]="true"
              ></app-curva-luminaria-chart>
            </div>

            <!-- Límites concretos de ESTA luminaria a partir de los cuales se
                 genera una alarma eléctrica -->
            @if (condicionesAlarmaElectricas.length > 0) {
              <div class="aviso info">
                <mat-icon>info</mat-icon>
                <div>
                  <span>
                    Se genera una alarma de
                    <strong>falla eléctrica</strong>
                    cuando la medición sale de estos límites:
                  </span>
                  <ul>
                    @for (linea of condicionesAlarmaElectricas; track $index) {
                      <li>{{ linea }}</li>
                    }
                  </ul>
                </div>
              </div>
            }
          </div>
        }
      </app-dt-card>

      <!-- Eventos por tipo de alarma de esta luminaria -->
      <app-dt-card
        titulo="Eventos por tipo de alarma"
        icono="report"
        class="tarjeta ancha"
      >
        <app-grafico-eventos-luminarias
          [idsLuminarias]="idsEventos"
          titulo="Eventos por tipo de alarma"
          altura="320px"
          [card]="false"
          [mostrarTitulo]="false"
        >
          <!-- Cuándo se genera cada evento, con los umbrales reales de esta
               luminaria. Va en la barra del gráfico, junto al toggle
               Abiertos/Histórico. -->
          @if (condicionesAlarma.length > 0) {
            <span toolbar-actions>
              <button
                irxBotonIcono
                type="button"
                [matMenuTriggerFor]="menuCondiciones"
                tooltip="¿Cuándo se genera cada evento?"
                aria-label="Ver condiciones de generación de eventos"
              >
                <mat-icon>help_outline</mat-icon>
              </button>
              <mat-menu
                #menuCondiciones="matMenu"
                class="menu-condiciones-alarma"
              >
                <div class="condiciones-menu">
                  <p class="condiciones-menu-titulo">
                    ¿Cuándo se genera cada evento?
                  </p>
                  @for (cat of condicionesAlarma; track cat.categoria) {
                    <div class="condiciones-cat">
                      <div class="condiciones-cat-header">
                        <mat-icon [style.color]="cat.color">
                          {{ cat.icon }}
                        </mat-icon>
                        <span>{{ cat.categoria }}</span>
                      </div>
                      <ul>
                        @for (l of cat.lineas; track $index) {
                          <li>{{ l }}</li>
                        }
                      </ul>
                    </div>
                  }
                </div>
              </mat-menu>
            </span>
          }
        </app-grafico-eventos-luminarias>
      </app-dt-card>

      <app-dt-card
        titulo="Encendido diario"
        icono="highlight"
        class="tarjeta ancha"
      >
        @if (encendidoDetallado.length > 0) {
          <app-tabla
            class="encendido-tabla"
            [name]="nameEncendido"
            [columnas]="columnasEncendidoDetallado"
            [datos]="encendidoDetallado"
            [totalCount]="totalCountEncendido"
            [(query)]="queryEncendido"
            (queryChange)="listarEncendidoDiario()"
            [pageSizeOptions]="helper.pageSizeOptions"
            [paginatorAbajo]="true"
            [paginatorArriba]="false"
            [buttonColumns]="false"
            [fillParent]="false"
          ></app-tabla>
        } @else {
          <span class="dt-muted">No hay datos de encendido diario</span>
        }
      </app-dt-card>

      <!-- Gráficos de las mediciones (potencia, voltaje, dimerización…) -->
      <app-dt-card
        titulo="Mediciones"
        icono="bolt"
        class="tarjeta ancha mediciones"
      >
        <app-detalles-luminaria-grafico
          [luminaria]="luminaria"
        ></app-detalles-luminaria-grafico>
      </app-dt-card>
    </div>
  </section>
} @else {
  <app-detalle-esqueleto soloCuerpo></app-detalle-esqueleto>
}
